import React from "react";

export default function AuthCallback() {
  return <div>Signing you in...</div>;
}